module.exports = __webpack_public_path__ + "img/slide1.00a4d191.png";